import { SubmissionError } from 'redux-form';
import { goToElement } from '../../utils/goToElement';

export const validateImportForm = values => {
	const file = values.file;
	if (!file) {
		throw new SubmissionError({ _error: 'Выберите файл для загрузки' });
	}

	return {};
};

export const transformToValidationErrors = errors => {
	goToElement(Object.keys(errors)[0]);
	return Object.entries(errors).reduce((acc, [key, messages]) => {
		acc[key] = Array.isArray(messages) ? messages.join(', ') : messages;
		return acc;
	}, {});
};
